import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 8vh;
  margin-bottom: 10px;
`;
export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
`;
export const Image = styled.img`
  width: 180px;
  height: 40px;
  margin: 10px;
`;
